export enum RoktEvent {
  PlacementReady = 'PLACEMENT_READY',
}
